import CancelIcon from '@mui/icons-material/Cancel';
import { Button,Dialog,DialogContent,IconButton,ImageListItemBar,Stack } from "@mui/material";
import { FaFileDownload } from "react-icons/fa";
import { trackEventMatomo } from "../../../helpers/matomo";

function ModalImagePreview({
  image,
  open,
  setOpen,
}: {
  image: string,
  open: boolean,
  setOpen: Function,
}) {

  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={open}
      onClose={() => {
        setOpen();
        trackEventMatomo('modal edita status PA', 'click', 'button', 'abre modal');
      }}
      scroll='paper'
    >
      <DialogContent dividers={true}>
        <Stack justifyContent='center' alignItems='center'>
          <ImageListItemBar
            title={<Button onClick={() => {
              trackEventMatomo('componente de imagem', 'click', 'button', 'download');
              const handleDownload = async () => {
                const a = document.createElement("a");
                a.href = await image;
                a.download = "axyma.png";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              };
              handleDownload();
            }
            } variant='contained' color='warning' endIcon={<FaFileDownload />}>
              Download
            </Button>}
            sx={{ padding: '5px' }}
            position="top"
            actionIcon={
              <IconButton onClick={() => setOpen(!open)} color="error" >
                <CancelIcon />
              </IconButton>}
          />
          <img
            style={{ maxHeight: 600, maxWidth: 600 }}
            src={image}
            alt='imagem axyma'
          />
        </Stack>
      </DialogContent>
    </Dialog>

  );
}

export default ModalImagePreview;